import React__default from 'react';
import { Button } from 'reactstrap';
import { Select } from '../../Form/Select/Select.js';
import dayjs from 'dayjs';
import range from '../../../../../../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/range.js';

const getMonth = (val) => {
    return dayjs(val).month();
};
const getYear = (val) => {
    return dayjs(val).year();
};
const months = range(0, 12, 1).map(m => {
    if (m < 9) {
        return { value: m.toString(), label: `0${(m + 1).toString()}` };
    }
    return { value: m.toString(), label: (m + 1).toString() };
});
const years = range(getYear(new Date()), getYear(new Date()) + 30, 1).map(y => {
    return { value: y.toString(), label: y.toString() };
});
const renderCustomHeader = (params) => {
    const { date: paramDate, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled } = params;
    return (React__default.createElement("div", { style: {
            margin: 10,
            display: 'flex',
            justifyContent: 'center'
        } },
        React__default.createElement(Button, { className: "react-datepicker__header-button", onClick: decreaseMonth, disabled: prevMonthButtonDisabled, outline: true },
            React__default.createElement("span", { className: "text-primary" }, '<')),
        React__default.createElement("div", { className: "react-datepicker__select__wrapper" },
            React__default.createElement(Select, { options: months, selectedOption: {
                    label: getMonth(paramDate).toString(),
                    value: getMonth(paramDate).toString()
                }, onChange: (m) => changeMonth(+m.value), getValue: (m) => m.value, getLabel: (m) => m.label })),
        React__default.createElement("div", { className: "react-datepicker__select__wrapper" },
            React__default.createElement(Select, { options: years, selectedOption: {
                    label: getYear(paramDate).toString(),
                    value: getYear(paramDate).toString()
                }, onChange: (y) => changeYear(+y.value), getValue: (y) => y.value, getLabel: (y) => y.label })),
        React__default.createElement(Button, { className: "react-datepicker__header-button", size: "sm", onClick: increaseMonth, disabled: nextMonthButtonDisabled, outline: true },
            React__default.createElement("span", { className: "text-primary" }, '>'))));
};

export { renderCustomHeader as default };
//# sourceMappingURL=RenderCustomHeader.js.map
